import React, { useEffect, useRef, useState } from "react";
import {
  Box, Button, Typography
} from "@mui/material";
import Header from "../../components/Header";
import ClientMap from "./ClientMap";
import { SortableItem } from "./SortableItem";

export default function MapRoute() {
  const [selectedClients, setSelectedClients] = useState([]); // ← 必要！
  const [baseLocation, setBaseLocation] = useState({ lat: 33.0, lng: 131.0 });
  const [sortedClients, setSortedClients] = useState([]);
  const mapRef = useRef(null);

  useEffect(() => {
    const stored = sessionStorage.getItem("selectedClients");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setSelectedClients(parsed);
        setSortedClients(parsed.filter(c => c && c.lat != null && c.lng != null));
      } catch (err) {

      }
    }
  }, []);
  const handleOptimize = () => {
    if (!baseLocation.lat || !baseLocation.lng) return;

    const origin = baseLocation;
    const destinations = sortedClients;

    // 仮の順序最適化（実際は API を使ってもよい）
    const optimized = [...destinations].sort((a, b) => {
      const da = Math.abs(a.lat - origin.lat) + Math.abs(a.lng - origin.lng);
      const db = Math.abs(b.lat - origin.lat) + Math.abs(b.lng - origin.lng);
      return da - db;
    });

    setSortedClients(optimized);
  };

  return (
    <>
      <Header />
      <Box p={2}>
        <Typography variant="h6" mb={2}>選択された顧客のルート表示</Typography>

        <ClientMap
          baseLocation={baseLocation}
          clients={sortedClients}
          mapRef={mapRef}
        />

        <Box mt={2}>
          <Typography variant="subtitle1">配達順（ドラッグで変更可）</Typography>
          {sortedClients.map(client => (
  <SortableItem key={client.id} client={client} />
))}
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={handleOptimize}
          sx={{ mt: 2 }}
          disabled={sortedClients.length === 0}
        >
          最適化する
        </Button>
      </Box>
    </>
  );
}
